import { createFileRoute } from '@tanstack/react-router'
import { claimTypesEnum } from 'User/utils/claims'
import WorkContainer from 'Work/containers/WorkContainer'
import { workQueries } from 'Work/utils/queries'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'
import { prefetchWhenAuthenticated } from '../-prefetch'

export const Route = createFileRoute('/work/$workId')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(context.queryClient, workQueries.detail(Number(params.workId))),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <WorkContainer />
        </Guard>
    ),
})
